export class MembershipLevel {
  club?: boolean; // 1 member program at a time
  lab?: boolean; // Unlimited member programs
  enterprise?: boolean; // Custom
}
